import './App.css';
import TableauReport from 'tableau-react';
import { useState, useEffect } from 'react';




function App() {
  const size = useWindowSize();

  const options = {
    height: size.height,
    width: size.width,
    hideTabs: true,
    // All other vizCreate options are supported here, too
    // They are listed here: https://help.tableau.com/current/api/js_api/en-us/JavaScriptAPI/js_api_ref.htm#vizcreateoptions_record
  };
  
  const filters = {
    Colors: ['Blue', 'Red'],
    Sizes: ['Small', 'Medium']
  };
  
  const parameters = {
    Param1: 'Value',
    Param2: 'Other Value'
  };

  function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });
  
    useEffect(() => {
      // Handler to call on window resize
      function handleResize() {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      
      // Add event listener
      window.addEventListener("resize", handleResize);
      
      // Call handler right away so state gets updated with initial window size
      handleResize();
      
      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
  
    return windowSize;
  }
  
  const MyReport = props => (
    <TableauReport
      url="https://prod-useast-a.online.tableau.com/t/allevianalytics/views/InteractiveDashboard/Home?:origin=card_share_link&:embed=n"
      filters={filters}
      parameters={parameters}
      options={options} // vizCreate options
      // Overwrite default query params
      // defaults to '?:embed=yes&:comments=no&:toolbar=yes&:refresh=yes'
      query="?:embed=yes&:comments=no&:toolbar=yes&:refresh=yes"
    />
  )
  return (
    <div className="App">
<MyReport></MyReport>

    </div>
  );
}

export default App;


// htn3QuIxTc+enzSimyFr9A==:5ZDwVa5AuVIbbIxMPFuxZDvtmp2AWRyS